import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';

const Nav = () => {
  const [activeItem, setActiveItem] = useState('');
  const history = useHistory();
  const location = useLocation();

  const links = [
    { name: 'Menú', url: '/menu/products', icon: 'food' },
    { name: 'Ganancias', url: '/earnings', icon: 'chart bar outline' },
    { name: 'Cuentas', url: '/bills', icon: 'file alternate outline' },
  ];

  // Set active item based on current path
  useEffect(() => {
    const currentPath = location.pathname;
    
    // Clear active item if on profile page
    if (currentPath.startsWith('/account')) {
      setActiveItem('');
      return;
    }
    
    const activeLink = links.find(link => currentPath.startsWith(link.url));
    if (activeLink) {
      setActiveItem(activeLink.name);
    }
  }, [location.pathname]);

  const handleItemClick = (e, { name, url }) => {
    setActiveItem(name);
    history.push(url);
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      display: 'flex',
      backgroundColor: '#4183c4',
      height: '60px',
      boxShadow: '0 -2px 5px rgba(0,0,0,0.1)',
      zIndex: 1000,
      width: '100%'
    }}>
      {links.map((link) => {
        const isActive = activeItem === link.name;
        
        return (
          <div
            key={link.url}
            onClick={() => handleItemClick(null, { name: link.name, url: link.url })}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              color: isActive ? 'white' : 'rgba(255,255,255,0.7)',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              height: '100%',
              padding: '5px 0'
            }}
          >
            <div 
              style={{
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                backgroundColor: isActive ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
                transition: 'background-color 0.2s ease',
                marginBottom: '3px'
              }}
            >
              <Icon 
                name={link.icon} 
                size="large" 
                style={{ 
                  margin: 0,
                  opacity: isActive ? 1 : 0.7
                }}
              />
            </div>
            <div style={{ 
              fontSize: '0.75em',
              fontWeight: isActive ? 'bold' : 'normal'
            }}>
              {link.name}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Nav;